import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { Clear, Done } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteGroup } from "../../../store/actions/groupAction";
import { parseVariables } from "../../../helpers/localize";
import parser from "html-react-parser";
import { showSanitizedInput } from "../../../helpers/inputProcessing";

const DeleteGroup = ({ group }) => {
  const { t } = useTranslation("group");

  const [open, setOpen] = useState(false);

  const handleClickClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        startIcon={<DeleteIcon fontSize="small" />}
        color="error"
        onClick={() => setOpen(true)}
        variant="contained"
        sx={{ boxShadow: 3 }}
      >
        {t("item.deleteBtn")}
      </Button>

      <DeleteGroupDialog
        open={open}
        group={group}
        handleClose={handleClickClose}
        doNavigate={true}
      />
    </>
  );
};

export const DeleteGroupDialog = ({ open, group, handleClose, doNavigate }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation("group");
  const { t: tCommon } = useTranslation();

  const handleDelete = (id) => {
    const payload = { id: id };
    dispatch(
      deleteGroup(payload, () => {
        if (doNavigate) navigate("/groups");
      })
    );
    handleClose();
  };

  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose}>
      <DialogContent>
        <DialogContentText sx={{ textAlign: "center", mb: 2 }}>
          {parser(
            parseVariables(t("item.deleteConfirmationText"), {
              name: showSanitizedInput(group.name),
            })
          )}
        </DialogContentText>

        <Box sx={{ textAlign: "center" }}>
          <Alert severity="warning" variant="outlined">
            {parser(t("item.deleteConfirmationHint"))}
          </Alert>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          color="error"
          variant="outlined"
          fullWidth
          startIcon={<Clear />}
          onClick={handleClose}
        >
          {tCommon("cancelBtn")}
        </Button>

        <Button
          color="error"
          variant="contained"
          fullWidth
          startIcon={<Done />}
          onClick={() => handleDelete(group.id)}
        >
          {tCommon("confirmBtn")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteGroup;
